import { Label } from '~/common/components/ui/label';
import { useEffect, useState } from 'react';
import { cn } from '~/common/utils/styleUtil';
import { Checkbox } from '~/common/components/ui/checkbox';

interface CheckSelectionItemFilterProps {
  checked?: boolean;
  onApplyFilter: (checked: boolean) => void;
  filterTitle: string;
  className?: string;
  disabled?: boolean;
}

export function CheckSelectionItemFilter({
  filterTitle,
  checked,
  onApplyFilter,
  className,
  disabled = false
}: Readonly<CheckSelectionItemFilterProps>) {
  const id = filterTitle.replaceAll(' ', '-').toLowerCase();

  const [localChecked, setLocalChecked] = useState(checked);

  const handleApplyFilter = (checked: boolean) => {
    setLocalChecked(checked);
    onApplyFilter(checked);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLocalChecked(checked);
  }, [checked]);

  return (
    <div className={className}>
      <div className={cn('flex items-center space-x-2 h-full')}>
        <Checkbox
          id={id}
          checked={localChecked}
          onCheckedChange={handleApplyFilter}
          data-testid={`filter-checkbox-${filterTitle}`}
          disabled={disabled}
        />
        <Label htmlFor={id}>{filterTitle}</Label>
      </div>
    </div>
  );
}
